// Expense reports — create + list.
import { useEffect, useState } from "react";
import { api } from "../../shared/api/client";
import { PageHeader } from "../../shared/components/PageHeader";
import { Empty, Loading } from "../../shared/components/Empty";
import { Pill } from "../../shared/components/Pill";
import { I } from "../../shared/Icon";
import { toast } from "../../shared/stores/toasts";

type Report = { id: number; title: string; total_amount: number; status: string; created_at: string; approval_doc_id: number | null };

export default function ExpensePage() {
  const [items, setItems] = useState<Report[] | null>(null);
  const [open, setOpen] = useState(false);

  const reload = () => api.get<Report[]>("/expense/reports").then((r) => setItems(r.data));
  useEffect(() => { reload(); }, []);

  return (
    <>
      <PageHeader title="경비" subtitle="지출결의 · 정산"
        right={<button className="t-btn t-btn-primary" onClick={() => setOpen(true)}><I.Plus size={14}/> 경비 청구</button>}
      />
      <div className="t-grid cols-1">
        {items === null && <Loading/>}
        {items?.length === 0 && <Empty msg="청구 내역이 없습니다"/>}
        <div className="t-card" style={{ padding: 0 }}>
          <div className="t-list" style={{ padding: 16 }}>
            {items?.map((r) => (
              <div key={r.id} className="t-row">
                <I.Receipt size={16} style={{ color: "var(--m-finance)" }}/>
                <span className="title" style={{ flex: 1 }}>{r.title}</span>
                <span className="num">{Math.round(r.total_amount).toLocaleString()}원</span>
                <Pill kind={r.status === "APPROVED" ? "ok" : r.status === "REJECTED" ? "danger" : "warn"}>{r.status}</Pill>
                <span className="meta">{new Date(r.created_at).toLocaleDateString("ko-KR")}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      {open && <CreateModal onClose={() => { setOpen(false); reload(); }} />}
    </>
  );
}

function CreateModal({ onClose }: { onClose: () => void }) {
  const [title, setTitle] = useState("");
  const [items, setItems] = useState([{ category: "MEAL", amount: 0, vat: 0, description: "", spent_at: new Date().toISOString().slice(0, 10) }]);
  const submit = async () => {
    try { await api.post("/expense/reports", { title, items }); toast.success("청구 완료", "결재 문서가 자동 생성되었습니다"); onClose(); }
    catch (e: any) { toast.error("실패", e?.response?.data?.error?.message); }
  };
  return (
    <div className="t-overlay" onClick={onClose}>
      <div className="t-cmdk" onClick={(e) => e.stopPropagation()} style={{ width: 560 }}>
        <div style={{ padding: 18, borderBottom: "1px solid var(--border)" }}><h3 style={{ margin: 0 }}>경비 청구</h3></div>
        <div style={{ padding: 18, display: "grid", gap: 12 }}>
          <div><label className="t-label">제목</label><input className="t-input" value={title} onChange={(e) => setTitle(e.target.value)}/></div>
          {items.map((it, i) => (
            <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8 }}>
              <select className="t-input" value={it.category} onChange={(e) => { const a = [...items]; a[i].category = e.target.value; setItems(a); }}>
                <option value="MEAL">식대</option>
                <option value="TRANSPORT">교통</option>
                <option value="ENTERTAINMENT">접대</option>
                <option value="SUPPLY">소모품</option>
                <option value="OTHER">기타</option>
              </select>
              <input type="number" className="t-input" placeholder="금액" value={it.amount} onChange={(e) => { const a = [...items]; a[i].amount = Number(e.target.value); setItems(a); }}/>
              <input type="number" className="t-input" placeholder="VAT" value={it.vat} onChange={(e) => { const a = [...items]; a[i].vat = Number(e.target.value); setItems(a); }}/>
              <input type="date" className="t-input" value={it.spent_at} onChange={(e) => { const a = [...items]; a[i].spent_at = e.target.value; setItems(a); }}/>
            </div>
          ))}
          <button className="t-btn t-btn-outline t-btn-sm" onClick={() => setItems([...items, { category: "MEAL", amount: 0, vat: 0, description: "", spent_at: new Date().toISOString().slice(0, 10) }])}>+ 항목 추가</button>
        </div>
        <div style={{ padding: 16, borderTop: "1px solid var(--border)", display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button className="t-btn" onClick={onClose}>취소</button>
          <button className="t-btn t-btn-primary" onClick={submit}>청구</button>
        </div>
      </div>
    </div>
  );
}
